import React, { useState } from "react";

const menu = [
    {
        category: "17:15",
        icon: "🍲",
        color: "orange",
        items: [
            { name: "Rosół", desc: "Tradycyjny rosół z domowym makaronem", veg: false },
            { name: "Polędwica wieprzowa w aksamitnym sosie z leśnych kurek", desc: "Z puree ziemniaczanym i chrupiącą kompozycją kapusty pekińskiej i świeżych warzyw", veg: false },
            { name: "Deser", desc: "Orzeźwiający pucharek lodowy z bukietem sezonowych owoców", veg: false },
            { name: "Menu dziecięce", desc: "Nuggetsy z frytkami 👶", veg: false },
        ],
    },
    {
        category: "19:15",
        icon: "🍗",
        color: "grape",
        items: [
            { name: "Delikatny filet z kurczaka", desc: "w towarzystwie aromatycznych ziemniaków opiekanych, serwowany z kremowym serkiem i grilowamymi warzywami", veg: false },
        ],
    },
    {
        category: "21:15",
        icon: "🎂",
        color: "lemon",
        items: [
            { name: "Uroczysty Tort Weselny", desc: "Tort pary młodej 💑", veg: false },
        ],
    },
    {
        category: "22:30",
        icon: "🥩",
        color: "lime",
        items: [
            { name: "Biesiadny półmisek specjałów grillowych z pieca", desc: "podawany z ziemniakami opiekanymi i surówką szwedzką", veg: false },
        ],
    },
    {
        category: "00:45",
        icon: "🍜",
        color: "peach",
        items: [
            { name: "Aromatyczna zupa węgierska z nutą wędzonej papryki", veg: false },
        ],
    },
    {
        category: "02:00",
        icon: "🥣",
        color: "orange",
        items: [
            { name: "Tradycyjny barszcz czerwony", desc: "Z chrupiącym, domowym krokietem 🌙", veg: false },
        ],
    },
    {
        category: "Przez całą noc",
        icon: "🥂",
        color: "grape",
        items: [
            { name: "Indygo Cocktail Bar", desc: "Open bar po pierwszym tańcu do 02:00 🍹", veg: false },
            { name: "Napoje bezalkoholowe", desc: "Dostępne przez całą noc", veg: true },
        ],
    },
    {
        category: "Przez całą noc",
        icon: "🥂",
        color: "lime",
        items: [
            { name: "Bimber", desc: "Przez całą noc do wyboru smak: Żurawina lub Cytryna 🍹", veg: false },
            { name: "Nalewska", desc: "Przez całą noc do wyboru smak: Malina lub Czarna porzeczka", veg: false },
        ],
    }
];

function Menu() {
    const [activeCategory, setActiveCategory] = useState(null);

    return (
        <div className="menu-section">
            <div className="menu-inner">
                <div className="eyebrow grape" style={{ justifyContent: "center" }}>
                    Co nas czeka
                </div>
                <h2 className="sec-title" style={{ textAlign: "center", marginBottom: "16px" }}>
                    Menu <em>weselne</em>
                </h2>

                {/* Kategorie */}
                <div className="menu-tabs">
                    <button
                        className={`menu-tab ${activeCategory === null ? "active" : ""}`}
                        onClick={() => setActiveCategory(null)}
                    >
                        Wszystko
                    </button>
                    {menu.map((cat) => (
                        <button
                            key={cat.category}
                            className={`menu-tab ${activeCategory === cat.category ? "active" : ""}`}
                            onClick={() => setActiveCategory(cat.category)}
                        >
                            {cat.icon} {cat.category}
                        </button>
                    ))}
                </div>

                {/* Menu grid */}
                <div className="menu-grid">
                    {menu
                        .filter((cat) => activeCategory === null || cat.category === activeCategory)
                        .map((cat, index) => (
                            <div key={index} className={`menu-card menu-card--${cat.color}`}>
                                <div className="menu-card-header">
                                    <span className="menu-card-icon">{cat.icon}</span>
                                    <span className="menu-card-category">{cat.category}</span>
                                </div>
                                <div className="menu-items">
                                    {cat.items.map((item, i) => (
                                        <div key={i} className={`menu-item ${item.veg ? "veg" : ""}`}>
                                            <div className="menu-item-name">
                                                {item.name}
                                                {item.veg && <span className="veg-badge">🌱</span>}
                                            </div>
                                            <div className="menu-item-desc">{item.desc}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                </div>

                {/* Info */}
                <div className="menu-info">
                    <div className="menu-info-item">
                        🥂 <strong>Open Bar</strong> — dostępny do godz. 02:00
                    </div>
                    <div className="menu-info-item">
                        🎂 <strong>Tort weselny</strong> — taki dobry, nie za słodki
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Menu;